import React, { useState } from 'react';
import CardCommon from '@/pages/opinion/components/CardCommon';
import ChannelsLanguageChart from '../../../Performance/components/ChannelsLanguageChart';
import { sentimentIcons } from '../../constants';
import { useDrilldownParams } from '@op/hooks/useDrilldownParams';
import { useHistory, useIntl } from 'umi';
import { isStatsDetail } from '../../utils';

export default function SentimentCharts({
  data,
  filter,
  loading,
  dataType,
  lang,
  handleStatsDetailOnClick,
  type = 'sentiment-s-bar',
  isVersion,
  regionType,
}: any) {
  const statsDetailType = 'stats-sentiment';
  const history = useHistory();
  const { goPage } = useDrilldownParams();

  const [activeSentiment, setActiveSentiment] = useState<
    'sentiment-h-bar' | 'sentiment-s-bar'
  >(type);

  const { formatMessage } = useIntl();

  const isDetail = isStatsDetail(history);
  return (
    <CardCommon
      title={formatMessage({ id: 'Sentiment' })}
      operations={sentimentIcons}
      defaultOperation={type}
      bodyStyle={{ height: 375 }}
      hasTitleArrow={!isDetail}
      handleTitleOnClick={() => {
        if (isDetail) {
          return;
        }
        goPage({
          path: '/opinion/Stats/Detail',
          filter: {
            filter,
            statsDetailType,
            statsDetailChartsData: {
              data,
              dataType,
              regionType,
            },
          },
        });
      }}
      handleOperationsOnClick={(item: any) => {
        setActiveSentiment(item.symbol);
      }}
    >
      <ChannelsLanguageChart
        dataType={dataType}
        data={data}
        filter={filter}
        lang={lang}
        height={290}
        loading={loading}
        type={activeSentiment}
        statsDetailType={statsDetailType}
        handleStatsDetailOnClick={handleStatsDetailOnClick}
        regionType={regionType}
      ></ChannelsLanguageChart>
    </CardCommon>
  );
}
